import {
  getBoolean,
  getRemoteConfig,
  fetchAndActivate,
} from "firebase/remote-config";
import { getApp } from "firebase/app";
import { FEATURE_FLAGS } from "./constants";
import { FeatureFlags } from "./interfaces";

/**
 * Override local de feature flags via window._env_ (env.js).
 * Os booleans vêm normalmente do Firebase Remote Config; as `FF_*` os sobrepõem quando setadas.
 * voicecallQualityConfig é override-only: o valor do Remote Config é ignorado.
 */
const applyEnvOverrides = (flags: Partial<FeatureFlags>): FeatureFlags => {
  const env = (typeof window !== "undefined" && (window as any)._env_) || {};
  const overridden = (key: string, current: boolean | undefined) =>
    env[key] === undefined ? !!current : env[key] === true || env[key] === "true";

  return {
    example: overridden("FF_EXEMPLO", flags.example),
    accountManagement: overridden(
      "FF_ACCOUNT_MANAGEMENT",
      flags.accountManagement,
    ),
  };
};

/**
 * @returns {Promise<FeatureFlags>}
 * @private Should only be used by useFeatureFlags
 */

export const getFeatureFlags = async (): Promise<FeatureFlags> => {
  try {
    const app = getApp();
    if (!app.name) {
      throw new Error("Não foi possível obter uma instância do Firebase.");
    }
    const remoteConfig = getRemoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 0;

    await fetchAndActivate(remoteConfig);

    return applyEnvOverrides({
      example: getBoolean(remoteConfig, FEATURE_FLAGS.EXEMPLO),
      accountManagement: getBoolean(
        remoteConfig,
        FEATURE_FLAGS.ACCOUNT_MANAGEMENT,
      ),
    });
  } catch (error) {
    console.warn("Não foi possível obter uma instância do Firebase:", error);
    return applyEnvOverrides({
      example: true,
      accountManagement: false,
    });
  }
};

